/* 🤖 this file was generated by script */
export const wiconApproveBell = {
  name: 'approve_bell',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6.7 16.82c.27.69.97 1.18 1.8 1.18.83 0 1.53-.5 1.8-1.18m0-13.48A4.9 4.9 0 008.5 3C5.96 3 3.76 4.96 3.76 7.39c0 3.5-.9 5.7-1.76 7.03h13c-.52-.8-1.16-1.9-1.5-3.42m0 0a4.5 4.5 0 111.29-8.81M13.5 11c2.2 0 4.02-1.63 4.42-3.69m-6.35-1.68l2.08 2.16L18 3.29"/></svg>`,
};
